module.exports = "/images/6bbde685301702f614e1d206058e6038.svg";